import { render, staticRenderFns } from "./Checkout.vue?vue&type=template&id=6f2c5d22&scoped=true&"
import script from "./Checkout.vue?vue&type=script&lang=js&"
export * from "./Checkout.vue?vue&type=script&lang=js&"
import style0 from "./Checkout.vue?vue&type=style&index=0&id=6f2c5d22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2c5d22",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QField});
